import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import HeaderTransprent from "../../components/HeaderTransprent";
import ContactForm from "../../ui/ContactForm";
import Footer from "../../components/Footer";
import Testimonial2 from "../../ui/Testimonial2";
import WhyThis from "../../ui/WhyThis";
import ButtonBrochure from "../../ui/ButtonBrochure";
import ContactFormJoinus from "../../ui/ContactFormJoinus";
import JsonData from "../../JsonData/jsonData.json";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaLinkedin, FaInstagram, FaYoutube, FaGlobe } from "react-icons/fa";
import { TbTargetArrow } from "react-icons/tb";
import { PiSuitcaseSimple } from "react-icons/pi";
import { IoLocationOutline, IoCalendarOutline } from "react-icons/io5";
import { IoSyncOutline, IoTrophyOutline, IoPeopleOutline, IoTimeOutline } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import { SiWikipedia } from "react-icons/si";
import { IoDocumentTextOutline } from "react-icons/io5";

const Award = ({ loggingIn, questions, user, assessment, ...props }) => {

  const formRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  // const [activeTab, setActiveTab] = useState(0);
  // const [openIndex, setOpenIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState("HWA 2025-26");
  // const listAgendaData = JsonData?.listAgendaData || {};
  const [activeIndividuals, setActiveIndividuals] = useState(0);

  // const dayData =
  //   activeTab === 0
  //     ? JsonData.listAgendaData[0]?.dayOneAgenda || []
  //     : activeTab === 1
  //       ? JsonData.listAgendaData[1]?.dayTwoAgenda || []
  //       : JsonData.listAgendaData[2]?.dayThreeAgenda || [];

  // const tabTitles = [
  //   "Day 1 | Feb 5th",
  //   "Day 2 | Feb 6th",
  //   "Day 3 | Feb 7th"
  // ];

  const tabIndividuals = [
    "Visionary People leader Award",
    "CEO Vision & Impact Award",
  ];


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOpenHWAForm = () => {
    setIsOpen(true);
  };

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleDownload = () => {
    const fileUrl = "/img/award25/Happiest Workplaces Annual Conclave 2026.pdf"; // Replace with your file URL
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "Happbit-Brochure.pdf"; // Optional custom name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const settingstwo = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    arrows: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  };

  const settingsthree = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: -1,
    autoplay: true,
    speed: 6000,
    arrows: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: -1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: -1
        }
      }

    ]

  };

  const getIcon = (social) => {
    switch (social) {
      case "linkedin":
        return <FaLinkedin className="w-5 h-5" />;
      case "instagram":
        return <FaInstagram className="w-5 h-5" />;
      case "youtube":
        return <FaYoutube className="w-5 h-5" />;
      case "wikipedia":
        return <SiWikipedia className="w-5 h-5" />;
      default:
        return <IoDocumentTextOutline className="w-5 h-5" />;
    }
  };

  return (
    <>
      <div className="overflow-hidden">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Happiness and Wellbeing Conclave 2024 | A Path to Personal and Professional Growth</title>
          <meta name="description" content="Explore the key takeaways from the Happiness and Wellbeing Conclave 2024. Discover expert insights, strategies, and moments that focused on enhancing mental health and overall wellbeing." />
          <link rel="canonical" href="https://happiestworkplaces.in/#/happiness-and-wellbeing-conclave-2024" />
        </Helmet>

        <HeaderTransprent />
        {/* Hero Section */}
        <section className="relative w-full h-auto overflow-hidden">
          {/* Background Video */}
          <video className="absolute top-0 left-0 w-full h-full object-cover" src="/img/award25/happiest-workplaces-annual-conclave-video.mp4" autoPlay loop muted playsInline />
          <div className="absolute inset-0"></div>
          <div className="relative z-10">
            <div className="w-full h-full py-10">
              <div className="flex flex-col w-full h-full gap-10 md:pt-5 md:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
                <div className="flex items-center flex-col justify-center w-full h-full py-10 mx-auto my-auto space-y-6 text-center md:pb-12 md:pt-0 md:text-left">
                  <div className="flex items-center gap-6">
                    <img data-aos="fade-left" src="/img/award25/HappyPlus-Logo-White.svg" alt="HappyPlus-Logo-White" className="h-[4.1rem]" />
                    <div className="border-l h-16 border-[#E91E63]" />
                    <img data-aos="fade-left" src="/img/award25/ETHRWorld-Logo-White.svg" alt="ETHRWorld-Logo-White" className="h-[4.1rem]" />
                  </div>
                  <div className="text-center">
                    <h1 className="text-white text-base font-medium md:text-lg text-center pb-4">Presents</h1>
                    {/* <h1 className="text-white text-xl font-semibold md:text-2xl text-center pb-1">4<sup>th</sup> EDITION </h1> */}
                    <img data-aos="fade-left" src="/img/award26/happiest-workplaces-annual-conclave-2027.svg" alt="HWAC-Logo-Whites" className="w-[21rem]" />
                  </div>
                  {/* <div data-aos="fade-right">
                    <p className="text-white text-base font-medium md:text-lg text-center">Powered by</p>
                    <div className="flex items-center gap-3">
                      <img data-aos="fade-left" src="/img/award25/adrenalin-white-logo.svg" alt="adrenalin-logo" className="h-12" />
                    </div>
                  </div>
                  <div className="flex md:justify-between justify-center md:flex-nowrap flex-wrap items-center md:gap-8 gap-4">
                    <div className="text-center">
                      <p className="text-white pb-4 text-base font-medium md:text-lg text-center">Publishing Partner</p>
                      <div className="flex items-center gap-3">
                        <img data-aos="fade-left" src="/img/award25/jaico-publishing-house-logo-white.svg" alt="jaico-publishing-house" className="h-8" />
                      </div>
                    </div>
                    <div className="md:w-px w-0 h-24 bg-[#FFFFFF]/50"></div>
                    <div className="text-center">
                      <p className="text-white pb-4 text-base font-medium md:text-lg text-center">Outreach Partner</p>
                      <div className="flex items-center gap-3">
                        <img data-aos="fade-left" src="/img/award25/fpj-logo-white.svg" alt="fpj-logo-white" className="h-[4.1rem]" />
                      </div>
                    </div>
                  </div> */}
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-6">
                    <div className="flex items-center space-x-2">
                      <IoCalendarOutline size={26} className="textcolor" />
                      <span className="text-white text-xl font-semibold md:text-2xl">12th March, 2027</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <IoLocationOutline size={26} className="textcolor" />
                      <span className="text-white text-xl font-semibold md:text-2xl">Taj Lands End Mumbai, India</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 justify-center pt-2">
                    <ButtonBrochure text="Register Now" onClick={handleScrollToForm} />
                    <ButtonBrochure text="Join as Partner" onClick={handleOpenHWAForm} />
                    {/* <ButtonBrochure text="Download Brochure" onClick={handleDownload} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Partners */}
        {/* <section className="w-full bg-gradient-to-t from-[#E91E63]/5 to-[#183889]/10">
          <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="text-center pb-10">
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Our Partners</h2>
            </div>
            <div class="flex justify-center">
              <div class="lg:w-[70%] w-full mx-auto border border-[#E91E63]/40 rounded-3xl px-16 py-10 text-center">
                <p class="textcolor font-semibold tracking-widest uppercase mb-5">Powered by</p>
                <div class="flex justify-center mb-10">
                  <div>
                    <img src="/img/award25/adrenalin-logo_black.svg" alt="Adrenalin Logo" class="mx-auto" />
                  </div>
                </div>
                <div class="grid md:grid-cols-2 grid-cols-1 gap-6">
                  <div>
                    <p class="textcolor font-semibold tracking-widest uppercase mb-5">PUBLISHING PARTNER</p>
                    <div class="">
                      <img src="/img/award25/jaico-publishing-house-logo.svg" alt="Jaico Publishing House Logo" class="mx-auto" />
                    </div>
                  </div>
                  <div>
                    <p class="textcolor font-semibold tracking-widest uppercase mb-5">OUTREACH PARTNER</p>
                    <div class="">
                      <img src="/img/award25/fpj-logo.svg" alt="Fpj-logo" class="mx-auto" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Happiness as Strategy */}
        <section className="w-full bg-[#FFFFFF]">
          <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="text-center pb-10">
              {/* <h1 className="pb-4 2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Overview</h1> */}
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Happiness as Strategy<br /> Growth as Outcome</h2>
            </div>
            <div className="space-y-6 lg:w-[70%] w-full mx-auto">
              <p className="text-lg text-[#212121] text-left font-semibold">India’s first leadership platform dedicated to positioning Employee Happiness as a core business strategy —  because happy people build productive organizations.</p>
              <p className="text-lg text-[#212121] text-left">This is not a conference. It is a Live Leadership Experience where personal insight meets workplace architecture.</p>
              <p className="text-lg text-[#212121] text-left">Leaders across industries will come together to reflect, learn and design the future of work — grounded in data, experience and shared responsibility.</p>
              <p className="text-lg text-[#212121] text-left textcolor font-semibold">100+ CXOs from leading organizations will participate to shape a national conversation on Happiness at Work.</p>
            </div>
          </div>
        </section>

        {/* Who Is This */}
        <section className="w-full bg-[#E91E63]/10">
          <div className="lex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 px-4 mx-auto">
            <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor text-center">Who Is This For?</h2>
            <p className="text-center md:text-2xl text-xl leading-5 capitalize font-semibold textblack mt-3">A curated circle of leaders who believe that people & performance thrive together: </p>
            {/* <p className="text-center text-lg textblack max-w-3xl mx-auto mt-3">The conclave is designed for the community of decision-makers and change leaders, committed to shaping the future of work.</p> */}

            <div className="flex items-center justify-center flex-wrap gap-6 mt-16">
              <div className="px-8 py-5 flex items-center gap-4 rounded-full bg-[#E91E63]/10 justify-start">
                <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-8 h-8" />
                <h3 className="text-xl font-semibold whitespace-nowrap textcolor">CXOs</h3>
              </div>
              <div className="px-8 py-5 flex items-center gap-4 rounded-full bg-[#E91E63]/10">
                <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-8 h-8" />
                <h3 className="text-xl font-semibold whitespace-nowrap textcolor">CHROs</h3>
              </div>
              <div className="px-8 py-5 flex items-center gap-4 rounded-full bg-[#E91E63]/10">
                <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-8 h-8" />
                <h3 className="text-xl font-semibold whitespace-nowrap textcolor">Talent and L&D Heads</h3>
              </div>
              <div className="px-8 py-5 flex items-center gap-4 rounded-full bg-[#E91E63]/10">
                <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-8 h-8" />
                <h3 className="text-xl font-semibold whitespace-nowrap textcolor">Business Leaders</h3>
              </div>
              <div className="px-8 py-5 flex items-center gap-4 rounded-full bg-[#E91E63]/10">
                <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-8 h-8" />
                <h3 className="text-xl font-semibold whitespace-nowrap textcolor">Industry Experts</h3>
              </div>
            </div>
          </div>
        </section>

        {/* Leaders Must */}
        <section className="bg-[#FFFFFF] py-16">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 md:px-5 px-4 mx-auto">
            <div className="text-center mb-8">
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor text-center">Why Leaders Must Be Here?</h2>
              {/* <p className="mt-3 text-lg textblack font-semibold text-center mb-12">
                Delegates Walk Away Not Just Inspired — But Equipped:
              </p> */}
            </div>
            <div className="grid md:grid-cols-2 gap-6 mb-10">
              {JsonData.whyLeadersData.map((cards, index) => (
                <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-6 shadow-sm">
                  <div className="w-16 h-16 flex items-center justify-center mb-5">
                    <img src={cards.imgs} alt={cards.title} className="w-16 h-16" />
                  </div>
                  <h3 className="md:text-xl text-lg font-semibold textcolor mb-3">{cards.title}</h3>
                  <ul className="list-disc pl-5 space-y-1">
                    {cards.points.map((point, i) => (
                      <li key={i} className="textblack text-sm leading-relaxed">
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-8 shadow-sm">
              <div className="flex items-center justify-start space-x-3 mb-6">
                <img src="/img/award25/every-delegate-leaves-with.svg" alt="every-delegate-leaves-with" className="w-16 h-16" />
                <h3 className="md:text-xl text-lg font-semibold textcolor">Every Delegate Leaves With</h3>
              </div>

              <div className="grid md:grid-cols-2 gap-y-6 gap-x-10 text-sm">
                <div className="flex items-start gap-5">
                  <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-6 h-6 mt-1" />
                  <div>
                    <p className="mb-2 md:text-lg text-base font-semibold textblack">Clarity</p>
                    <p className="textblack">Understanding happiness as a measurable organizational reality</p>
                  </div>
                </div>
                <div className="flex items-start gap-5">
                  <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-6 h-6 mt-1" />
                  <div>
                    <p className="mb-2 md:text-lg text-base font-semibold textblack">Conviction</p>
                    <p className="textblack">Seeing happiness as strategy, not sentiment</p>
                  </div>
                </div>
                <div className="flex items-start gap-5">
                  <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-6 h-6 mt-1" />
                  <div>
                    <p className="mb-2 md:text-lg text-base font-semibold textblack">Capability</p>
                    <p className="textblack">Designing systems that convert happiness into growth</p>
                  </div>
                </div>
                <div className="flex items-start gap-5">
                  <img src="/img/award25/circel-check.svg" alt="circel-check" className="w-6 h-6 mt-1" />
                  <div>
                    <p className="mb-2 md:text-lg text-base font-semibold textblack">Connection</p>
                    <p className="textblack">Meaningful relationships with the community committed to transforming how workplaces think, lead, and grow.</p>
                  </div>
                </div>
              </div>

              <p className="mt-8 text-center font-semibold text-black lg:text-xl text-lg">
                This is where leaders reset the workplace agenda — from engagement activities to Happiness as Strategy.
              </p>
            </div>

          </div>
        </section>

        {/* Magazine Launch */}
        {/* <section class="bg-black flex flex-col items-center justify-start py-16 px-4 font-sans text-white">
          <div class="text-center z-10">
            <h2 class="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-center">Magazine Launch</h2>
            <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor text-center">WISDOM AND INSIGHTS</h2>
            <p class="text-xl md:text-3xl text-gray-100">Stories Of Grit, Growth, And Greatness</p>
          </div>

          <div class="relative w-full max-w-5xl flex flex-col items-center">
            <div class="absolute top-[-70px] md:top-[-150px] w-full max-w-3xl opacity-80 pointer-events-none">
              <img src="/img/award25/wisdom-and-insights-bg.webp" alt="Background Figures" class="w-full h-auto" />
            </div>
            <div class="relative z- w-full mt-32 md:mt-44 bg-[#1a1a1a] rounded-[2rem] md:rounded-[3rem] overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.8)] border border-white/5">
              <div class="w-full">
                <img src="/img/award25/wisdom-and-insights-magazine-launch-HWAC.webp" alt="People holding magazine" class="w-full h-auto block" />
              </div>
              <div class="bg-[#E91E4E] p-4 text-center">
                <p class="text-sm md:text-lg font-medium leading-relaxed text-white max-w-4xl mx-auto">
                  Discover The Untold Journeys Of India's Top HR And Business Leaders In This Exclusive New
                  Publication By Happy Plus Consulting. Featuring In-Depth Interviews With Visionaries And
                  Uncovering Their Strategies For Resilience, Innovation, And Workplace Excellence.
                </p>
              </div>
            </div>
          </div>
        </section> */}

        {/* Organization Winners */}
        {/* <section className="w-full space-y-6 bg-cover" style={{ backgroundImage: `url('/img/assessment/bg-gradient.webp')` }}>
          <div className="w-full h-full bg-white">
            <div className="flex flex-col justify-start w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="text-center">
                <h1 className="text-xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-semibold text-[#183889]">Organization Winners</h1>
                <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Congratulations</h1>
              </div>
              <div class="w-full bg-white rounded-[2rem] border border-pink-100 mt-8">
                <div class="bg-gradient-to-r from-[#183889] to-[#E91E63] py-1 px-4 rounded-tl-[2rem] rounded-tr-[2rem]">
                  <h1 className="2xl:text-2xl md:text-xl text-lg xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-white text-center">Happiest Workplaces 2025-26</h1>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 py-8 px-6">
                  {JsonData.companyAwards25.slice(0, 15).map((logo, index) => (
                    <div key={index} className="text-center border px-4">
                      <img className="w-full" src={logo.src} alt={logo.name} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Individuals Winners*/}
        {/* <section className="w-full space-y-6 bg-cover" style={{ backgroundImage: `url('/img/assessment/bg-gradient.webp')` }}>
          <div className="w-full h-full bg-white">
            <div className="flex flex-col justify-start w-full h-full pb-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="text-center pb-8">
                <h1 className="text-xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-semibold text-[#183889]">Individuals Winners</h1>
                <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Congratulations</h1>
              </div>

              <div class="w-full bg-white rounded-[2rem] border border-pink-100">
                <div class="bg-gradient-to-r from-[#183889] to-[#E91E63] py-1 px-4 rounded-tl-[2rem] rounded-tr-[2rem]">
                  <h1 className="2xl:text-2xl md:text-xl text-lg xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-white text-center">CEO Vision & Impact Award 2025-26</h1>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 py-8 px-6">
                  {JsonData.congratesIndividuals25.slice(10, 14).map((congrates, index) => (
                    <div key={index} className="flex flex-col bg-white">
                      <img alt="" className="object-cover w-full bg-gray-500" src={congrates.src} />
                      <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                        <h2 className="text-xl font-bold text-[#212121]">{congrates.name}</h2>
                        <p className="text-sm text-[#212121]">{congrates.designation}</p>
                      </div>
                      <button onClick={() => window.open(congrates.link, "_blank")} className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3 space-x-3">
                        <FaLinkedin className="w-5 h-5 text-white" />
                        <span>LinkedIn</span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div class="w-full bg-white rounded-[2rem] border border-pink-100 mt-8">
                <div class="bg-gradient-to-r from-[#183889] to-[#E91E63] py-1 px-4 rounded-tl-[2rem] rounded-tr-[2rem]">
                  <h1 className="2xl:text-2xl md:text-xl text-lg xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-white text-center">Visionary People leader Award 2025-26</h1>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 py-8 px-6">
                  {JsonData.congratesIndividuals25.slice(0, 10).map((congrates, index) => (
                    <div key={index} className="flex flex-col bg-white">
                      <img alt="" className="object-cover w-full bg-gray-500" src={congrates.src} />
                      <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                        <h2 className="text-xl font-bold text-[#212121]">{congrates.name}</h2>
                        <p className="text-sm text-[#212121]">{congrates.designation}</p>
                      </div>
                      <button onClick={() => window.open(congrates.link, "_blank")} className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3 space-x-3">
                        <FaLinkedin className="w-5 h-5 text-white" />
                        <span>LinkedIn</span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Highlights Of 4th HWR Conclave 2026 */}
        {/* <section class="flex items-center justify-center py-16 bg-gradient-to-r from-[#183889] to-[#E91E63]">
          <div class="max-w-6xl w-full aspect-[4/5] md:aspect-video rounded-3xl flex flex-col items-center justify-between px-4 md:px-6 text-white ">
            <div class="text-center z-10 max-w-6xl">
              <h1 class="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold mb-4">Highlights Of 4th HWR Conclave 2026</h1>
              <p class="text-lg leading-relaxed font-semibold opacity-90">HWR Conclave 2026 Positioned Employee Happiness As A Strategic Business Driver, And Explored How Happier Teams Lead To Better Productivity, Retention, And Long-Term Growth. It Also Recognized The Organization That Build Meaningful, Sustainable Work Environments Via Happiest Workplaces Research 2025–26.</p>
            </div>

            <div class="relative w-full aspect-video rounded-2xl overflow-hidden my-8">
              <iframe src="https://www.youtube.com/embed/E8stpvxPcfo?controls=1&rel=0" title="Video" frameborder="0" allow="autoplay; fullscreen" class="w-full h-full"></iframe>
              <div class="absolute bottom-6 left-0 right-0 flex flex-col items-center gap-1 z-10">
                <span class="bg-white text-black font-black px-4 py-1 rounded-sm text-[10px] md:text-xs uppercase tracking-widest shadow-md">Top Leaders Gather at Taj Lands End,</span>
                <span class="bg-red-600 text-white font-black px-4 py-1 rounded-sm text-[10px] md:text-xs uppercase tracking-widest shadow-md">Bandra for Future of Work Talks</span>
              </div>
            </div>

            <div class="text-center z-10">
              <p class="text-3xl font-bold tracking-wide">Mumbai Hosts Happiest Workplaces Conclave 2026 | 100+ CXOs Discuss Future Of Work</p>
            </div>
          </div>
        </section> */}

        {/* Key Discussion Points */}
        <section className="bg-[#FFFFFF] py-16">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 md:px-5 px-4 mx-auto">
            <div className="text-center mb-8">
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor text-center">Key Discussion Points</h2>
              {/* <p className="mt-3 text-lg textblack font-semibold text-center mb-12">
                Delegates Walk Away Not Just Inspired — But Equipped:
              </p> */}
            </div>
            <div className="grid md:grid-cols-2 gap-6 mb-10">
              <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-6 shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center mb-4 bg-[#E91E63]/10 rounded-xl">
                  <TbTargetArrow className="w-12 h-12 textcolor" />
                </div>
                <h3 className="md:text-xl text-lg font-semibold textcolor mb-2">Meaning</h3>
                <p className="textblack text-sm leading-relaxed">Human Relevance in an AI Economy: How organizations ensure people remain contributors — not observers — as technology absorbs tasks.</p>
              </div>

              <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-6 shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center mb-4 bg-[#E91E63]/10 rounded-xl">
                  <IoSyncOutline className="w-12 h-12 textcolor" />
                </div>
                <h3 className="md:text-xl text-lg font-semibold textcolor mb-2">Being</h3>
                <p className="textblack text-sm leading-relaxed">Capability vs Adaptability: Empower people in the always-on world to continuously learn, unlearn, and re-learn instead of protecting fixed roles.</p>
              </div>

              <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-6 shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center mb-4 bg-[#E91E63]/10 rounded-xl">
                  <IoTrophyOutline className="w-12 h-12 textcolor" />
                </div>
                <h3 className="md:text-xl text-lg font-semibold textcolor mb-2">Achievements</h3>
                <p className="textblack text-sm leading-relaxed">Activating talent to sustain performance as expertise has a shrinking shelf life in always-connected environments. Know your real talent to achieve meaningful success.</p>
              </div>

              <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-6 shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center mb-4 bg-[#E91E63]/10 rounded-xl">
                  <PiSuitcaseSimple className="w-12 h-12 textcolor" />
                </div>
                <h3 className="md:text-xl text-lg font-semibold textcolor mb-2">Work and Life</h3>
                <p className="textblack text-sm leading-relaxed">Redesigning work where humans collaborate with systems instead of competing with them.</p>
              </div>

              <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-6 shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center mb-4 bg-[#E91E63]/10 rounded-xl">
                  <IoPeopleOutline className="w-12 h-12 textcolor" />
                </div>
                <h3 className="md:text-xl text-lg font-semibold textcolor mb-2">Relationships</h3>
                <p className="textblack text-sm leading-relaxed">Re-establishing trust, authority, and support as expectations shift across generations. Workplace happiness is shaped by the quality of relationships people experience daily.</p>
              </div>

              <div className="bg-[#E91E63]/10 rounded-md border border-pink-100 p-6 shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center mb-4 bg-[#E91E63]/10 rounded-xl">
                  <IoTimeOutline className="w-12 h-12 textcolor" />
                </div>
                <h3 className="md:text-xl text-lg font-semibold textcolor mb-2">Time</h3>
                <p className="textblack text-sm leading-relaxed">Present – Make your past and future memorable and remarkable.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Session Spotlight */}
        {/* <section className="bg-gradient-to-t from-[#E91E63]/5 to-[#183889]/10 py-16">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 md:px-5 px-4 mx-auto">
            <div className="text-center mb-8">
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor text-center">Session Spotlight</h2>
                         </div>
            <div className="bg-white/30 rounded-2xl shadow-sm border border-[#E91E63]/40 p-6 md:px-10 md:py-12">
              <div className="flex flex-col md:flex-row gap-10 items-center">
                <div className="w-full md:w-[35%] text-center md:text-left">
                  <div className="flex justify-center md:justify-start">
                    <div className="rounded-2xl overflow-hidden w-80 h-96 md:w-[27rem] md:h-[29rem]">
                      <img src="/img/award25/srinivasa-bharathy.webp" alt="srinivasa-bharathy" className="w-full h-full object-cover" />
                    </div>
                  </div>
                  <p className="mt-4 textcolor font-semibold md:text-2xl text-xl text-center">By Srinivasa Bharathy</p>
                  <p className="textblack md:text-xl text-lg text-center">MD & CEO, Adrenalin</p>
                </div>
                <div className="w-full md:w-[65%]">
                  <h3 className="text-3xl md:text-4xl font-bold textblack leading-snug">
                    The Happiness Dividend of AI in HR
                  </h3>
                  <p className="textblack text-lg md:text-xl leading-relaxed my-6">
                    The promise was liberation & Happiness. The reality? Often, just more dashboards, more grunt work. This masterclass confronts the central paradox of AI in HR: technology designed to free us can sometimes leave us more frazzled than ever.
                  </p>
                  <p className="textblack text-lg md:text-xl leading-relaxed">
                    Join us to explore how the most forward-thinking organizations are flipping the script; using AI not as another tool to manage, but as a catalyst for reclaiming what matters most: meaningful work, energized teams, and measurable impact that commands C-suite attention. For HR leaders, get ready to architect joy, not just efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}


        {/* Why This */}
        <section className="bg-[#FFFFFF] py-16">
          <div className="flex flex-col justify-start w-full h-full md:px-5 px-4 mx-auto">
            <div className="text-center mb-8">
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor text-center">Why This Conclave More Critical Now</h2>
            </div>
            <WhyThis />
          </div>
        </section>

        {/* Flow of the Day */}
        {/* <section className="w-full bg-gradient-to-b from-[#E91E63]/10 via-[#183889]/10 to-[#FFFFFF]">
          <div className="w-full h-full">
            <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 px-4 mx-auto">
              <div className="text-center pb-12">
                <h1 className="2xl:text-5xl md:text-4xl text-3xl font-bold textcolor">Flow of the Day</h1>
              </div>

              <div className="hidden md:block overflow-x-auto">
                <table className="min-w-full text-sm text-left border-collapse">
                  <thead className="bg-[#E91E63] text-white text-base font-semibold">
                    <tr>
                      <th className="p-4 border-b border-[#E91E63]/30 w-44">Time</th>
                      <th className="p-4 border-b border-[#E91E63]/30">Session Title</th>
                      <th className="p-4 border-b border-[#E91E63]/30">Format</th>
                      <th className="p-4 border-b border-[#E91E63]/30">Objective</th>
                      <th className="p-4 border-b border-[#E91E63]/30">Looking forward for</th>
                    </tr>
                  </thead>
                  <tbody className="textblack">
                    {JsonData.eventSchedule.map((item, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-white"}>
                        <td className="p-3 border-b border-gray-300 text-[#1e3a8a] font-semibold">{item.time}</td>
                        <td className="p-3 border-b border-gray-300 font-semibold">{item.title}</td>
                        <td className="p-3 border-b border-gray-300 textcolor font-semibold">{item.format}</td>
                        <td className="p-3 border-b border-gray-300">{item.objective}</td>
                        <td className="p-3 border-b border-gray-300">{item.takeaway}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="grid gap-4 md:hidden">
                {JsonData.eventSchedule.map((item, index) => (
                  <div key={index} className="border border-blue-200 rounded-xl p-4 shadow-sm">
                    <p className="text-xs font-semibold text-blue-600 mb-1">{item.time}</p>
                    <h3 className="font-bold text-blue-900 mb-2">{item.title}</h3>
                    <p className="text-sm"><span className="font-semibold">Format:</span> {item.format}</p>
                    <p className="text-sm"><span className="font-semibold">Objective:</span> {item.objective}</p>
                    <p className="text-sm"><span className="font-semibold">Looking forward for:</span> {item.takeaway}</p>
                  </div>
                ))}
              </div>

              <p className="mt-6 lg:text-2xl text-xl font-semibold textcolor">Joining the Conclave positions us among the nation’s leading organizations building workplaces where people love to work and businesses scale faster!</p>
            </div>
          </div>
        </section> */}

        {/* Our Esteemed Speaker */}
        {/* <section className="w-full bg-gradient-to-t from-[#E91E63]/5 to-[#183889]/10">
          <div className="flex flex-col justify-start w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="text-center pb-12">
              <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Our Esteemed Speaker</h1>
            </div>
            <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
              {JsonData.esteemedSpeaker.map((items, index) => {
                return (
                  <div key={index} className="flex flex-col bg-white">
                    <img alt="" className="object-cover w-full bg-gray-500" src={items.src} />
                    <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                      <h2 className="text-xl font-bold text-[#212121]">{items.name}</h2>
                      <p className="text-sm text-[#212121]">{items.designation}</p>
                    </div>
                    <button onClick={() => window.open(items.link, "_blank")} className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3 space-x-3">{getIcon(items.social)}<span className="capitalize">{items.social}</span>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </section> */}

        {/* Honourable Guests */}
        {/* <section className="w-full bg-[#FFFFFF]">
          <div className="flex flex-col justify-start w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="text-center pb-12">
              <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Honourable Guests</h1>
            </div>
            <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
              {JsonData.honourableLeaders.map((items, index) => {
                return (
                  <div key={index} className="flex flex-col bg-white">
                    <img alt="" className="object-cover w-full bg-gray-500" src={items.src} />
                    <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                      <h2 className="text-xl font-bold text-[#212121]">{items.name}</h2>
                      <p className="text-sm text-[#212121]">{items.designation}</p>
                    </div>
                    {items.name === "Kinny Singh" ? (
                      <button
                        onClick={() => window.open(items.link, "_blank")}
                        className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-pink-600 hover:bg-[#183889] px-6 py-3 space-x-3"
                      >
                        <FaInstagram className="w-5 h-5 text-white" />
                        <span>Instagram</span>
                      </button>
                    ) : (
                      items.link && (
                        <button
                          onClick={() => window.open(items.link, "_blank")}
                          className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3 space-x-3"
                        >
                          <FaLinkedin className="w-5 h-5 text-white" />
                          <span>LinkedIn</span>
                        </button>
                      ))}
                  </div>
                );
              })}
            </div>
          </div>
        </section> */}

        {/* Event Partners */}
        {/* <section className="w-full bg-gradient-to-b from-[#E91E63]/10 via-[#183889]/10 to-[#FFFFFF]">
          <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="text-center pb-12">
              <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Event Partners</h1>
            </div>

            <div className="pb-4 pt-2 text-center">
              <h1 className="text-3xl font-semibold">Coming Soon!</h1>
            </div>
          <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
              {JsonData.speakers26.map((speakers26, index) => {
                return (
                  <div key={index} className="flex flex-col bg-white">
                    <img alt="" className="object-cover w-full bg-gray-500" src={speakers24.src} />
                    <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                      <h2 className="text-xl font-bold text-[#212121]">{speakers24.name}</h2>
                      <p className="text-sm text-[#212121]">{speakers24.designation}</p>
                    </div>
                    <button onClick={() => window.open(speakers24.link, "_blank")} className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] hover:text-white px-6 py-3 space-x-3">
                      <FaLinkedin className="w-5 h-5 text-white" />
                      <span>LinkedIn</span>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </section> */}


        {/* <AllCompnayLogo /> */}

        <Testimonial2 />


        <section className="md:bg:right bg-[#2196F3]/10 bg-cover bg-no-repeat bg-center py-20 w-full h-auto" style={{ backgroundImage: `url('/img/home/hero-bg.webp')`, }}>
          <h2 className="font-bold text-3xl md:text-4xl 2xl:text-5xl text-center capitalize textcolor">Glimpse of HWA Event</h2>
          <div className="my-10">
            <div className="flex gap-4 px-4 md:px-10 lg:px-36 xl:px-72 w-full overflow-x-auto md:overflow-visible no-scrollbar justify-start md:justify-center scroll-smooth">
              {["HWA 2025-26", "HWA 2024", "HWA 2023", "HWA 2022"].map((year) => (
                <div
                  key={year}
                  onClick={() => setSelectedTab(year)}
                  className={`flex items-center gap-2 rounded-md cursor-pointer transition-all duration-150 py-3 px-6 text-sm md:text-lg font-semibold whitespace-nowrap flex-shrink-0 md:flex-shrink ${selectedTab === year
                    ? "bg-gradient-to-b from-[#F8BBD0] to-transparent textcolor"
                    : "bg-gradient-to-b from-[#212121]/10 to-white text-[#212121]"
                    }`}
                >
                  <img src="/img/home/trophy.svg" alt="trophy" className="w-5 h-5 md:w-6 md:h-6" />
                  <span>{year}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image Grid Wrapper */}
          {selectedTab === "HWA 2025-26" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              {/* Left Side Extra Blocks */}
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider {...settingstwo} className="w-full">
                    {JsonData.awardImage25.slice(0, 15).map((awardImage25, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage25.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider {...settingsthree} className="w-full">
                    {JsonData.awardImage25.slice(15, 30).map((awardImage25, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage25.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}

          {selectedTab === "HWA 2024" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              {/* Left Side Extra Blocks */}
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider {...settingstwo} className="w-full">
                    {JsonData.awardImage24.slice(0, 15).map((awardImage24, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage24.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider {...settingsthree} className="w-full">
                    {JsonData.awardImage24.slice(15, 30).map((awardImage24, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage24.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}
          {selectedTab === "HWA 2023" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider  {...settingstwo} className="w-full" >
                    {JsonData.awardImage23.slice(0, 15).map((awardImage23, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage23.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider  {...settingsthree} className="w-full" >
                    {JsonData.awardImage23.slice(15, 30).map((awardImage23, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage23.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}
          {selectedTab === "HWA 2022" && (
            <div className="flex justify-center items-center space-x-2 mt-10">
              <div className="space-y-4 overflow-hidden">
                <div className="flex space-y-10">
                  <Slider  {...settingstwo} className="w-full" >
                    {JsonData.awardImage22.slice(0, 15).map((awardImage22, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage22.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
                <div className="flex space-y-10">
                  <Slider  {...settingsthree} className="w-full" >
                    {JsonData.awardImage22.slice(15, 30).map((awardImage22, index) => (
                      <div className='px-4' key={index}>
                        <img src={awardImage22.url} title='happyplus-happiness-and-wellbeing' alt="happyplus-happiness-and-wellbeing" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          )}

        </section>

        <section ref={formRef} className="bg-cover bg-no-repeat" style={{ backgroundImage: `url('/img/home/bg-03.webp')`, }}>
          <div className="bg-gradient-to-b from-[#E91E63]/10 via-[#183889]/10 to-[#FFFFFF]">
            <div className="flex flex-col justify-start w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto ">
              <div className="mx-auto px-4 py-12 w-full">
                <div className="flex flex-col lg:flex-row">

                  <div className="lg:w-1/2 flex flex-col justify-center mb-8 md:mb-0 pr-0 md:pr-8">
                    <h1 className="text-4xl md:text-5xl font-bold textcolor mb-6 leading-tight">
                      Ready to leap from feedback to action?
                    </h1>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">
                      Invest in your people today.<br />
                      If not now, when?
                    </h2>
                    <p className="text-lg text-gray-700">
                      Let's build an organization where, people feel good about how they contribute to the whole!
                    </p>
                  </div>
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </section>

        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true">
            <div className="bg-white w-full max-w-[840px] overflow-hidden shadow-2xl flex flex-col md:flex-row max-h-[90vh]">
              <div className="w-full px-8 pt-4 pb-6 overflow-auto">
                <div className="flex items-end justify-end">
                  <button onClick={() => setIsOpen(false)} aria-label="Close modal" className="top-2 text-[#212121]">
                    <MdClose size={22} />
                  </button>
                </div>
                {/* <h2 className="lg:text-4xl text-3xl font-extrabold textcolortwo">To partner with us, please fill in your details</h2> */}
                <ContactFormJoinus />
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div >
    </>
  );
};

Award.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};

export default Award;
